// Certificate model
class Certificate {
  constructor(
    id = '',
    certificate_no = '',
    company_name = '',
    company_address = '',
    issue_date = '',
    expiry_date = '',
    company_type = '',
    scope = '',
    first_date = '',
    second_date = '',
    status = true,
    certificate_standard = '',
    created_at = ''
  ) {
    this.id = id;
    this.certificate_no = certificate_no;
    this.company_name = company_name;
    this.company_address = company_address;
    this.issue_date = issue_date;
    this.expiry_date = expiry_date;
    this.company_type = company_type;
    this.scope = scope;
    this.first_date = first_date;
    this.second_date = second_date;
    this.status = status;
    this.certificate_standard = certificate_standard;
    this.created_at = created_at;
  }
}

export default Certificate;
